import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/lock2.png'
import _imports_1 from '@/assets/images/basic-version.png'
import _imports_2 from '@/assets/images/advanced-version.png'
import _imports_3 from '@/assets/images/qrcode-br-lb.png'
import _imports_4 from '@/assets/images/qrcode-br-rb.png'
import _imports_5 from '@/assets/images/qrcode-br-rt.png'
import _imports_6 from '@/assets/images/qrcode-br-lt.png'


const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "card-image" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "filter"
}
const _hoisted_5 = { class: "lock-area" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "permission-level-container"
}
const _hoisted_8 = { class: "permission-level-inner" }
const _hoisted_9 = {
  key: 0,
  src: _imports_1,
  class: "permission-icon"
}
const _hoisted_10 = {
  key: 1,
  src: _imports_2,
  class: "permission-icon"
}
const _hoisted_11 = {
  key: 2,
  class: "permission-time"
}
const _hoisted_12 = {
  key: 0,
  class: "sort"
}
const _hoisted_13 = { class: "card-content" }
const _hoisted_14 = { class: "info" }
const _hoisted_15 = { class: "sub-info" }
const _hoisted_16 = { class: "card-fade" }
const _hoisted_17 = {
  key: 0,
  class: "controls"
}
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 1,
  class: "qr-modal"
}
const _hoisted_21 = { class: "qr-modal-body" }
const _hoisted_22 = { class: "qr-code-wrapper" }
const _hoisted_23 = { class: "qr-code-placeholder" }
const _hoisted_24 = ["src"]

import { ref, onMounted, onUnmounted,onBeforeMount, nextTick, computed, watch} from 'vue';
import {ICard} from '@/types/baseInterFace'
const designWidth = 1920;
const designHeight = 1080;
const cardDesignWidth = 450;
const cardDesignHeight = 654;


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  cardsList: {
    type: Array as () => ICard[],
    default:()=> []
  },
  useControls: {
    type: Boolean,
    default: true,
  },
  isShowSort: {
    type: Boolean,
    default: false,
  },
  isShowMode:{
    type: Boolean,
    default: false
  },
  isShowLock:{
    type: Boolean,
    default: false
  },
  supportSelect: {//是否支持默认选中卡片，通关模式中要做最后一个解锁的卡片选中
    type: Boolean,
    default: false,
  },
  isUseFade: {//是否支持默认选中卡片，通关模式中要做最后一个解锁的卡片选中
    type: Boolean,
    default: true,
  },
  currentPage:{
    type: Number,
    default: 0
  },
  isShowBuyButton: {//是否显示购买按钮
    type: Boolean,
    default: false,
  },
  selectedCardId: {
    type: [String, Number],
    default: null,
  },
},
  emits: ["onClick"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit
const translateX = ref<number>(0);
const activeIndex = ref<number>(0);
const isHovering = ref<boolean>(false);
const cardWidth = ref<number>(0);
const totalCardWidth = ref<number>(0);
const cards = ref<HTMLElement[]>([]);
const container = ref<HTMLElement | null>(null);
let resizeObserver: ResizeObserver | null = null;
let cardNum = ref<number>(3)
const showQrModal = ref<boolean>(false)
const selectedCardIdInner = ref<string | number | null>(props.selectedCardId ?? null)
const disableTransition = ref(false)
const shouldRestoreWithoutAnimation = ref(false)
const skipNextSelectedSyncMove = ref(false)

const cardStyle = ref({
  width: '450px',
  height: '654px'
});

const qrcodeUrl = ref<string>('')

const getScrollMetrics = () => {
  const total = props.cardsList.length;
  const card = cards.value[0];
  const containerEl = container.value;
  if (!total || !card || !containerEl) {
    return {
      containerWidth: 0,
      width: 0,
      cardGap: 0,
      step: 0,
      totalCardsWidth: 0,
      maxTranslateX: 0,
    };
  }

  const containerWidth = containerEl.offsetWidth;
  const width = card.offsetWidth;
  const cardGap = parseFloat(window.getComputedStyle(card).marginRight) || 0;
  const step = width + cardGap;
  const totalCardsWidth = total * width + (total - 1) * cardGap;
  const maxTranslateX = Math.min(0, containerWidth - totalCardsWidth);

  return {
    containerWidth,
    width,
    cardGap,
    step,
    totalCardsWidth,
    maxTranslateX,
  };
};

const getMaxActiveIndex = (): number => {
  if (!totalCardWidth.value) return 0;
  const { maxTranslateX } = getScrollMetrics();
  return Math.max(0, Math.ceil(Math.abs(maxTranslateX) / totalCardWidth.value));
};

const resolveMaxActiveIndex = (total: number = props.cardsList.length): number => {
  if (cards.value[0] && container.value) {
    return getMaxActiveIndex();
  }
  return Math.max(0, total - cardNum.value);
};

const syncActiveIndexByTranslate = () => {
  if (!totalCardWidth.value) {
    activeIndex.value = 0;
    return;
  }
  activeIndex.value = Math.max(0, Math.round(Math.abs(translateX.value) / totalCardWidth.value));
};

const clampTranslateX = (value: number): number => {
  const { maxTranslateX } = getScrollMetrics();
  if (value > 0) return 0;
  if (value < maxTranslateX) return maxTranslateX;
  return value;
};

const isAtLeftEdge = (): boolean => translateX.value >= -0.5;

const isAtRightEdge = (): boolean => {
  const { maxTranslateX } = getScrollMetrics();
  return translateX.value <= maxTranslateX + 0.5;
};

const setTranslateX = (value: number, immediate = false): void => {
  if (!immediate) {
    translateX.value = value;
    return;
  }
  disableTransition.value = true;
  translateX.value = value;
  nextTick(() => {
    requestAnimationFrame(() => {
      disableTransition.value = false;
    });
  });
};

const getSelectedIndex = (list: ICard[]): number => {
  if (props.selectedCardId === null || props.selectedCardId === undefined) return -1;
  return list.findIndex(item => String(item.id) === String(props.selectedCardId));
};

watch(()=>props.cardsList, (newValue) => { 
  selectedCardIdInner.value = props.selectedCardId ?? null
  if(Array.isArray(newValue) && newValue.length > 0){
    const selectedIndex = getSelectedIndex(newValue)
    if (selectedIndex >= 0) {
      activeIndex.value = selectedIndex
      shouldRestoreWithoutAnimation.value = true
    } else if(props.supportSelect){ 
      let index = newValue.findIndex(item=>item.isLocked === true)
      // let index = 13;
      if(index <= 0){
        activeIndex.value = 0
      }else if(resolveMaxActiveIndex(newValue.length) > (index - 1)){
        activeIndex.value = index - 1
      }else{
        activeIndex.value = resolveMaxActiveIndex(newValue.length)
      }  
    }
  } else {
    activeIndex.value = 0
  }
  if (totalCardWidth.value > 0) {
    setTranslateX(clampTranslateX(-activeIndex.value * totalCardWidth.value), shouldRestoreWithoutAnimation.value);
    shouldRestoreWithoutAnimation.value = false;
    syncActiveIndexByTranslate();
  } else {
    // 宽度尚未计算完成时，不提前消费“无动画恢复”标记，
    // 让 updateCardDimensions 首次定位时再决定是否瞬移。
    if (!shouldRestoreWithoutAnimation.value) {
      setTranslateX(0, false);
    }
  }
},{ immediate: true ,deep: true});

watch(() => props.selectedCardId, (newValue) => {
  selectedCardIdInner.value = newValue ?? null
  if (skipNextSelectedSyncMove.value) {
    skipNextSelectedSyncMove.value = false;
    return;
  }
  if (!Array.isArray(props.cardsList) || props.cardsList.length === 0) return;
  const selectedIndex = getSelectedIndex(props.cardsList);
  if (selectedIndex < 0) return;
  activeIndex.value = selectedIndex;
  shouldRestoreWithoutAnimation.value = true;
  if (totalCardWidth.value > 0) {
    setTranslateX(clampTranslateX(-activeIndex.value * totalCardWidth.value), true);
    shouldRestoreWithoutAnimation.value = false;
    syncActiveIndexByTranslate();
  }
});

const scale = computed(() => {
  // 同时考虑宽度和高度，取最小值确保卡片完整显示
  return Math.min(
    window.innerWidth / designWidth,
    window.innerHeight / designHeight
  );
});
const handleClick = (card:ICard)=>{
  console.log('handleClick-------------',card)
  if(props.isShowLock && card.isLocked){
    return
  }
  // 点击时父层会回传 selectedCardId，这一轮只更新高亮，不触发列表重新定位
  skipNextSelectedSyncMove.value = true;
  selectedCardIdInner.value = card.id ?? null
  window?.playClick()
  emit('onClick', card)
}

const showQrCode = (card:ICard) => {
  if(!card?.qrcodeUrl) return;
  window?.playClick?.()
  const base = (process.env as any).VUE_APP_FILE_URL || ''
  qrcodeUrl.value = base + card?.qrcodeUrl
  showQrModal.value = true
}

const closeQrModal = () => {
  window?.playClick?.()
  showQrModal.value = false
}

const setCardDimensions = () => { 
  // const scale = window.innerHeight / designHeight; // 以高度为基准缩放
  cardStyle.value = {
    width: `${cardDesignWidth * scale.value}px`,
    height: `${cardDesignHeight * scale.value}px`,
  };
};
const updateCardDimensions = () => {
  setCardDimensions();
  if (cards.value.length > 0 && cards.value[0] && container.value) {
    const metrics = getScrollMetrics();
    cardNum.value = Math.max(1, Math.floor((metrics.containerWidth + metrics.cardGap) / metrics.step));
    totalCardWidth.value = metrics.step;

    // 尺寸变化后根据当前选中索引重算位置，再限制到边界内
    setTranslateX(clampTranslateX(-activeIndex.value * totalCardWidth.value), shouldRestoreWithoutAnimation.value);
    shouldRestoreWithoutAnimation.value = false;
    syncActiveIndexByTranslate();
  }
};
const scrollLeft = (isWheel:false | true): void => {
  if (!isAtLeftEdge()) {
    if(!isWheel){
      window?.playClick()
    }
    setTranslateX(clampTranslateX(translateX.value + totalCardWidth.value));
    syncActiveIndexByTranslate();
  }
};

const scrollRight = (isWheel?:boolean): void => {
  if (!isAtRightEdge()) {
    if(!isWheel){
      window?.playClick()
    }
    setTranslateX(clampTranslateX(translateX.value - totalCardWidth.value));
    syncActiveIndexByTranslate();
  }
};

const handleWheel = (e: WheelEvent): void => {
  if (!isHovering.value) return;
  
  if (e.deltaY > 0) {
    scrollRight(true);
  } else {
    scrollLeft(true);
  }
};

const handleMouseEnter = (): void => {
  isHovering.value = true;
};

const handleMouseLeave = (): void => {
  isHovering.value = false;
};

const handleKeyDown = (e: KeyboardEvent): void => {
  if (e.key === 'ArrowLeft') {
    scrollLeft(true);
  } else if (e.key === 'ArrowRight') {
    scrollRight(true);
  }
};

const handleResize = () => {
  updateCardDimensions();
};

onMounted(() => {
  console.log('onMounted-------------',props.cardsList)
  window.addEventListener('keydown', handleKeyDown);
  window.addEventListener('resize', handleResize);
  nextTick(() => {
    updateCardDimensions();
    if (container.value) {
      resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(container.value);
    }
  });
});

onUnmounted(() => {
  window.removeEventListener('keydown', handleKeyDown);
  window.removeEventListener('resize', handleResize);
  if (resizeObserver) {
    resizeObserver.disconnect();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "card-carousel-container",
    ref_key: "container",
    ref: container
  }, [
    _createElementVNode("div", {
      class: "card-carousel",
      onWheel: _withModifiers(handleWheel, ["prevent"]),
      onMouseenter: handleMouseEnter,
      onMouseleave: handleMouseLeave
    }, [
      _createElementVNode("div", {
        class: "card-wrapper",
        style: _normalizeStyle({ transform: `translateX(${translateX.value}px)`, transition: disableTransition.value ? 'none' : undefined })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cardsList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(['card', {'active-card': selectedCardIdInner.value !== null && String(selectedCardIdInner.value) === String(item.id)}]),
            ref_for: true,
            ref_key: "cards",
            ref: cards,
            style: _normalizeStyle(cardStyle.value),
            onClick: ($event: any) => (handleClick(item))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                class: "card-img",
                src: item.pictureUrl,
                alt: ""
              }, null, 8, _hoisted_3),
              (props.isShowLock && item.isLocked)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _cache[3] || (_cache[3] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
                      (props.isShowBuyButton)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(['coming-soon-box',item?.qrcodeUrl?'buy-btn':'coming-soon-btn']),
                            onClick: _withModifiers(($event: any) => (showQrCode(item)), ["stop"])
                          }, [
                            _createElementVNode("p", null, _toDisplayString(item?.qrcodeUrl?'立即购买':'敬请期待'), 1)
                          ], 10, _hoisted_6))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (props.currentPage == 1 && !item.isLocked && item?.permissionLevel !== undefined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      (item?.permissionLevel == 0)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                        : _createCommentVNode("", true),
                      (item?.permissionLevel == 1)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                        : _createCommentVNode("", true),
                      (item?.endTime)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.endTime) + " 到期", 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (__props.isShowSort)
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(item.sortIndex), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("p", _hoisted_14, _toDisplayString(item.title), 1),
              _createElementVNode("p", _hoisted_15, _toDisplayString(item.description), 1)
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "inset" }, null, -1))
          ], 14, _hoisted_1))
        }), 128))
      ], 4),
      _withDirectives(_createElementVNode("div", _hoisted_16, null, 512), [
        [_vShow, props.cardsList.length && __props.isUseFade]
      ])
    ], 32),
    (__props.useControls && props.cardsList.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (scrollLeft(false))),
            disabled: isAtLeftEdge()
          }, _cache[5] || (_cache[5] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M15 18l-6-6 6-6" })
            ], -1)
          ]), 8, _hoisted_18),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (scrollRight(false))),
            disabled: isAtRightEdge()
          }, _cache[6] || (_cache[6] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M9 18l6-6-6-6" })
            ], -1)
          ]), 8, _hoisted_19)
        ]))
      : _createCommentVNode("", true),
    (showQrModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", {
            class: "qr-modal-overlay",
            onClick: closeQrModal
          }),
          _createElementVNode("div", {
            class: "qr-modal-content",
            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", { class: "qr-modal-header" }, [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "qr-modal-title" }, "扫码购买", -1)),
              _createElementVNode("div", {
                class: "qr-modal-close",
                onClick: closeQrModal
              }, _cache[7] || (_cache[7] = [
                _createElementVNode("svg", {
                  width: "16",
                  height: "16",
                  viewBox: "0 0 16 16",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M12 4L4 12M4 4L12 12",
                    stroke: "currentColor",
                    "stroke-width": "1.5",
                    "stroke-linecap": "round"
                  })
                ], -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _cache[9] || (_cache[9] = _createElementVNode("img", {
                    src: _imports_3,
                    alt: "",
                    class: "qrcode-br-lb"
                  }, null, -1)),
                  _cache[10] || (_cache[10] = _createElementVNode("img", {
                    src: _imports_4,
                    alt: "",
                    class: "qrcode-br-rb"
                  }, null, -1)),
                  _cache[11] || (_cache[11] = _createElementVNode("img", {
                    src: _imports_5,
                    alt: "",
                    class: "qrcode-br-rt"
                  }, null, -1)),
                  _cache[12] || (_cache[12] = _createElementVNode("img", {
                    src: _imports_6,
                    alt: "",
                    class: "qrcode-br-lt"
                  }, null, -1)),
                  _createElementVNode("img", {
                    class: "qr-code-img",
                    src: qrcodeUrl.value,
                    alt: "qrcode"
                  }, null, 8, _hoisted_24)
                ])
              ]),
              _cache[13] || (_cache[13] = _createElementVNode("p", { class: "qr-text" }, "打开微信扫码购买", -1)),
              _cache[14] || (_cache[14] = _createElementVNode("p", { class: "qr-subtext" }, "支付成功后请刷新页面！", -1))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})